import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import './App.css';

// Admin-only: anonymized visit stats for a given year.
const VisitStats = () => {
   const authHeader = useAuthHeader();
   const currentYear = new Date().getFullYear();
   const [year, setYear] = useState(currentYear);
   const [dailyStats, setDailyStats] = useState([]);
   const [totals, setTotals] = useState({ totalUniqueVisits: 0, totalPageViews: 0 });
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState('');

   const loadStats = async (selectedYear) => {
      setLoading(true);
      setError('');
      try {
         const response = await axios.get('/stats/visits', {
            params: { year: selectedYear },
            headers: { Authorization: authHeader() },
         });
         setDailyStats(response.data.dailyStats || []);
         setTotals({
            totalUniqueVisits: response.data.totalUniqueVisits || 0,
            totalPageViews: response.data.totalPageViews || 0,
         });
      } catch (err) {
         console.error('Failed to load visit stats:', err);
         setError('Failed to load visit stats.');
      } finally {
         setLoading(false);
      }
   };

   useEffect(() => {
      loadStats(year);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [year]);

   const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

   return (
      <div className="main-style">
         <div className="player-entry-form">
            <p>
               Anonymized visit counts based on page loads. Visitors are counted
               per day only (no tracking across days), so the yearly total is a
               sum of daily unique visits, not a deduplicated count of people.
            </p>

            <div className="margin-top-medium">
               <label className="form-label" htmlFor="statsYear">Year:</label>
               <select
                  className="form-select"
                  id="statsYear"
                  value={year}
                  onChange={(e) => setYear(Number(e.target.value))}
               >
                  {yearOptions.map((y) => (
                     <option key={y} value={y}>{y}</option>
                  ))}
               </select>
            </div>

            {error && <div className="error-message margin-top-medium">{error}</div>}
            {loading && <p className="margin-top-medium">Loading stats...</p>}

            {!loading && !error && (
               <>
                  <div className="margin-top-medium">
                     <p><strong>Total unique visits:</strong> {totals.totalUniqueVisits.toLocaleString()}</p>
                     <p><strong>Total page views:</strong> {totals.totalPageViews.toLocaleString()}</p>
                  </div>

                  {dailyStats.length === 0 ? (
                     <p className="margin-top-medium">No visit data recorded for {year}.</p>
                  ) : (
                     <table className="scoreboard-table margin-top-medium">
                        <thead>
                           <tr>
                              <th>Date</th>
                              <th>Unique Visitors</th>
                              <th>Page Views</th>
                           </tr>
                        </thead>
                        <tbody>
                           {dailyStats.map((day) => (
                              <tr key={day.visitDate}>
                                 <td>{day.visitDate}</td>
                                 <td>{day.uniqueVisitors.toLocaleString()}</td>
                                 <td>{day.pageViews.toLocaleString()}</td>
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  )}
               </>
            )}
         </div>
      </div>
   );
};

export default VisitStats;
